import { createContext, useContext } from "react";
import { Widget } from "../../models/Widget";

export interface DashboardContextType {
    editMode: boolean;
    onDelete: (key: string) => void;
    widgets: any[];
    onReload: () => void;
    setIsDraggable: (isDraggable: boolean) => void;
    onEditReload: (widget: Widget) => void;
}

const defaultDashboardContextValue: DashboardContextType = {
    editMode: false,
    onDelete: (key: string) => {},    
    widgets: [],
    onReload: () => {},
    setIsDraggable: (isDraggable: boolean) => {},
    onEditReload: (widget: Widget) => {}
}  

export const DashboardContext = createContext<DashboardContextType>(defaultDashboardContextValue);

export const useDashboardContext = () => {
    return useContext(DashboardContext);
}